import { useKeycloak } from '@react-keycloak/web';
import type { AuthService, AuthUser } from './AuthService';
import { openAccount } from './accountUrl';

// Unified authentication hook that works with Keycloak
export const useAuth = (): AuthService => {
  const { keycloak, initialized } = useKeycloak();
  
  const user: AuthUser | null = keycloak?.tokenParsed ? {
    name: keycloak.tokenParsed.name || 'Unknown User',
    email: keycloak.tokenParsed.email || '',
    username: keycloak.tokenParsed.preferred_username || '',
    roles: keycloak.tokenParsed.realm_access?.roles || [],
    picture: keycloak.tokenParsed.picture || undefined
  } : null;

  return {
    initialized,
    authenticated: !!keycloak?.authenticated,
    user,
    login: () => keycloak?.login(),
    logout: () => keycloak?.logout(),
    accountManagement: () => openAccount(keycloak),
    token: keycloak?.token || null,
    hasRole: (role: string) => keycloak?.hasRealmRole(role) || false
  };
};
